import { Alert, Spin } from "antd";
import AntdCard, { CardProps as AntCardProps } from "antd/es/card/Card";

export type CardProps = AntCardProps & {
  isLoading?: boolean;
  error?: Error | null;
  children: React.ReactNode;
};

export const Card: React.FC<CardProps> = (props) => {
  const { children, isLoading, error, ...cardProps } = props;
  return (
    <AntdCard
      bordered={false}
      classNames={{
        body: "flex flex-col justify-center items-center min-h-64",
      }}
      className="w-full"
      {...cardProps}
    >
      {isLoading ? (
        <Spin size="large" />
      ) : error instanceof Error ? (
        <Alert
          message="Error"
          description={error.message}
          type="error"
          showIcon
        />
      ) : (
        children
      )}
    </AntdCard>
  );
};
